import React from 'react';
import MaterialExecutors from './MaterialExecutors';

export default class SpouseExecutors extends MaterialExecutors {
  static forSpouse = true;
}
